var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"massBalanceTitle"},[_vm._v(" "+_vm._s(_vm.$t('massBalance.pageName'))+" ")]),_c('div',{staticClass:"massBalanceDevicesWrapper"},[_c('CoolingTowerComponent'),_c('BoilerComponent'),_c('Simplified')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }